import React, { useState } from 'react';
import {
  IconButton,
  Popover,
  styled,
  Tooltip,
} from '@mui/material';
import {
  AddReaction as AddReactionIcon,
} from '@mui/icons-material';

interface ReactionPickerProps {
  onSelect: (emoji: string) => void;
}

const COMMON_REACTIONS = ['👍', '❤️', '😊', '🎉', '🤔', '👏', '😮', '😢'];

const EmojiGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: theme.spacing(0.5),
  padding: theme.spacing(1),
}));

const EmojiButton = styled(IconButton)(({ theme }) => ({
  fontSize: '1.5rem',
  padding: theme.spacing(0.5),
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    transform: 'scale(1.2)',
  },
}));

const ReactionPicker: React.FC<ReactionPickerProps> = ({ onSelect }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (emoji: string) => {
    onSelect(emoji);
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title="Add reaction">
        <IconButton size="small" onClick={handleOpen} style={{ opacity: 0.6 }}>
          <AddReactionIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <EmojiGrid>
          {COMMON_REACTIONS.map((emoji) => (
            <EmojiButton key={emoji} onClick={() => handleSelect(emoji)}>
              {emoji}
            </EmojiButton>
          ))}
        </EmojiGrid>
      </Popover>
    </>
  );
};

export default ReactionPicker;
